/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ClientsControllerFindAllQueryResponse, ClientsControllerFindAllQueryParams, ClientsControllerFindAll401, ClientsControllerFindAll403 } from "../../models/clientsController/ClientsControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { clientsControllerFindAll } from "../../clients/clientsService/clientsControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const clientsControllerFindAllQueryKey = (params: ClientsControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/clients'
}, ...(params ? [params] : [])] as const;
export type ClientsControllerFindAllQueryKey = ReturnType<typeof clientsControllerFindAllQueryKey>;
export function clientsControllerFindAllQueryOptions(params?: ClientsControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = clientsControllerFindAllQueryKey(params);
  return queryOptions<ClientsControllerFindAllQueryResponse, ResponseErrorConfig<ClientsControllerFindAll401 | ClientsControllerFindAll403>, ClientsControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return clientsControllerFindAll(params, config);
    }
  });
}

/**
 * @summary Get all clients
 * {@link /api/v1/clients}
 */
export function useClientsControllerFindAll<TData = ClientsControllerFindAllQueryResponse, TQueryData = ClientsControllerFindAllQueryResponse, TQueryKey extends QueryKey = ClientsControllerFindAllQueryKey>(params?: ClientsControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<ClientsControllerFindAllQueryResponse, ResponseErrorConfig<ClientsControllerFindAll401 | ClientsControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? clientsControllerFindAllQueryKey(params);
  const query = useQuery({
    ...clientsControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ClientsControllerFindAll401 | ClientsControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}